module.exports = __webpack_public_path__ + "img/arow_up.e31e421e.svg";